import React, { useState } from 'react';
import styled from 'styled-components';
import DashboardNavbar from '../components/Header';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Bg = styled.div`
  min-height: 80vh;;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Card = styled.div`
  background: #a3adb6;
  border-radius: 16px;
  padding: 40px 32px 32px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 320px;
  max-width: 95vw;
  box-shadow: 0 2px 16px rgba(0,0,0,0.08);
  @media (max-width: 500px) {
    min-width: 0;
    width: 98vw;
    padding: 28px 8vw 24px 8vw;
  }
`;

const Heading = styled.h2`
  color: #fff;
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 32px;
  letter-spacing: 1px;
  text-align: center;
`;

const Input = styled.input`
  width: 260px;
  max-width: 80vw;
  padding: 16px 18px;
  margin-bottom: 22px;
  border: none;
  border-radius: 10px;
  background: #fff;
  font-size: 1.1rem;
  font-weight: 600;
  color: #444;
  letter-spacing: 1px;
  outline: none;
  box-sizing: border-box;
  @media (max-width: 500px) {
    width: 100%;
    padding: 13px 12px;
    font-size: 1rem;
  }
`;

const DoneButton = styled.button`
  background: #111;
  color: #fff;
  border: none;
  border-radius: 50px;
  padding: 10px 32px;
  font-size: 1.1rem;
  font-weight: 600;
  margin-top: 8px;
  letter-spacing: 2px;
  cursor: pointer;
  transition: background 0.18s;
  &:hover:not(:disabled) {
    background: #333;
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const ErrorMessage = styled.p`
  color: #ff4444;
  font-size: 0.9rem;
  margin-bottom: 16px;
  text-align: center;
  background: rgba(255, 68, 68, 0.1);
  padding: 8px 12px;
  border-radius: 8px;
`;

const SuccessMessage = styled.p`
  color: #22c55e;
  font-size: 0.9rem;
  margin-bottom: 16px;
  text-align: center;
  background: rgba(34, 197, 94, 0.1);
  padding: 8px 12px;
  border-radius: 8px;
`;

const ForgatePassword = () => {
  const navigate = useNavigate();
  const [oldPass, setOldPass] = useState('');
  const [newPass, setNewPass] = useState('');
  const [confirmPass, setConfirmPass] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    // Validation
    if (!oldPass || !newPass || !confirmPass) {
      setError('All fields are required');
      return;
    }

    if (newPass.length < 6) {
      setError('New password must be at least 6 characters long');
      return;
    }

    if (newPass !== confirmPass) {
      setError('New password and confirm password do not match');
      return;
    }

    if (oldPass === newPass) {
      setError('New password must be different from old password');
      return;
    }

    try {
      setLoading(true);
      const user = JSON.parse(localStorage.getItem('user'));
      
      if (!user || !user.id) {
        setError('User not found. Please login again.');
        setTimeout(() => navigate('/login'), 2000);
        return;
      }

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/change-password`,
        {
          userId: user.id,
          oldPassword: oldPass,
          newPassword: newPass,
        }
      );

      if (response.status === 200) {
        setSuccess('Password changed successfully! Redirecting...');
        
        // Update user in localStorage with new isLogin status
        const updatedUser = { ...user, isLogin: true };
        localStorage.setItem('user', JSON.stringify(updatedUser));

        // Clear form
        setOldPass('');
        setNewPass('');
        setConfirmPass('');

        // Redirect to home page after 2 seconds
        setTimeout(() => {
          navigate('/');
          window.location.reload();
        }, 2000);
      }
    } catch (error) {
      console.error('Change password error:', error);
      setError(error.response?.data?.message || 'Failed to change password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <DashboardNavbar/>
      <Bg>
        <Card>
          <Heading>Change Password</Heading>
          
          {error && <ErrorMessage>{error}</ErrorMessage>}
          {success && <SuccessMessage>{success}</SuccessMessage>}

          <form onSubmit={handleChangePassword}>
            <Input
              type="password"
              placeholder="OLD PASSWORD"
              value={oldPass}
              onChange={e => setOldPass(e.target.value)}
              disabled={loading}
            />
            <Input
              type="password"
              placeholder="NEW PASSWORD"
              value={newPass}
              onChange={e => setNewPass(e.target.value)}
              disabled={loading}
            />
            <Input
              type="password"
              placeholder="CONFIRM PASSWORD"
              value={confirmPass}
              onChange={e => setConfirmPass(e.target.value)}
              disabled={loading}
            />
            <DoneButton type="submit" disabled={loading}>
              {loading ? 'Processing...' : 'Done'}
            </DoneButton>
          </form>
        </Card>
      </Bg>
    </>
  );
};

export default ForgatePassword;
